import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-fail-loading-receipt',
	templateUrl: './fail-loading-receipt.component.html',
	styleUrls: ['./fail-loading-receipt.component.scss'],
	standalone: false,
})
export class FailLoadingReceiptComponent {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			component: FailLoadingReceiptComponent,
			cssClass: 'auto-height item-modal reduced-width-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});
		return await modal.present();
	}

	closeReceiptError() {
		this.modalCtrl.dismiss();
	}
}
